<template>
  <b-media
    class="notification-card"
    :class="(!notification.isRead && unReadNotifications!=0) && 'notification-card--active'"
  >
    <template #aside>
      <b-avatar
        size="42"
        :variant="displayNotification.type"
        :src="getAvatar(displayNotification.avatar)"
      >
        <feather-icon
          v-if="!displayNotification.avatar"
          :icon="displayNotification.icon"
        />
      </b-avatar>
    </template>
    <div class="media-heading d-flex justify-content-between mb-0">
      <p class="media-heading d-flex align-items-center mb-0">
        <span class="font-weight-bolder">
          {{ displayNotification.title }}
        </span>
        <feather-icon
          v-if="!notification.isRead && unReadNotifications!=0"
          icon="CircleIcon"
          size="8"
          fill="#3D61AD"
          class="ml-1 text-primary"
        />
      </p>
      <div v-if="notification.notification.verificationAction === 'REQUESTED'">
        <b-badge
          v-if="notification.notification.invoice.verifiedAt"
          variant="success"
        >
          Approved
        </b-badge>
        <b-badge
          v-if="notification.notification.invoice.rejectedAt"
          variant="danger"
        >
          Rejected
        </b-badge>
      </div>
    </div>

    <small class="notification-text">{{ displayNotification.subtitle }}</small>

    <!-- Review Button -->
    <div class="text-right">
      <b-button
        v-if="!notification.notification.invoice.verifiedAt && !notification.notification.invoice.rejectedAt"
        size="sm"
        variant="primary"
        @click="EventBus.$emit('notification-action', { modalId: `review-invoice-${notification.notification.invoice.invoiceId}-modal`, notification })"
      >
        Review
      </b-button>
    </div>
    <div class="text-right">
      <small class="text-mute">
        {{ fromNow(UTCtoLocal(displayNotification.createdAt)) }}
      </small>
    </div>
  </b-media>
</template>
<script>
import { getUserData } from '@/auth/utils'
import {
  BMedia, BAvatar, BButton, BBadge,
} from 'bootstrap-vue'
import EventBus from '@/event-bus'

export default {
  components: {
    BMedia,
    BAvatar,
    BButton,
    BBadge,
  },
  props: {
    notification: {
      type: [Array, Object],
      default: () => {},
    },
    unReadNotifications: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      EventBus,
      invoice: {},
      self: getUserData(),
    }
  },
  computed: {
    displayNotification() {
      const {
        notification, creator, isRead, uuid, createdAt,
      } = this.notification
      const { user } = notification

      let type = ''
      let action = ''
      switch (notification.verificationAction) {
      case 'REQUESTED':
        type = 'light-info'
        action = 'verification'
        break
      case 'DECLINED':
        type = 'light-danger'
        break
      default:
        type = 'light-success'
      }

      const creatorName = creator.uuid === this.self.uuid ? 'You have' : `${creator.name} has`
      let subtitle = `${creatorName} ${notification.verificationAction.toLowerCase()} an invoice ${notification.verificationAction === 'REQUESTED' ? 'verification' : ''} (invoice Id: ${notification.invoice.invoiceId})`

      if (notification.invoice.rejectedAt) {
        subtitle = `${user.uuid === this.self.uuid ? 'You have' : `${user.name} has`} rejected the invoice (invoice Id: ${notification.invoice.invoiceId})`
        type = 'light-danger'
      }

      if (notification.invoice.verifiedAt) {
        subtitle = `${user.uuid === this.self.uuid ? 'You have' : `${user.name} has`} approved the invoice (invoice Id: ${notification.invoice.invoiceId})`
        type = 'light-success'
      }

      return {
        title: `Invoice ${action} ${notification.verificationAction.toLowerCase()}!`, subtitle, type, icon: 'userIcon', avatar: notification.user.avatar, isRead, uuid, createdAt,
      }
    },
  },
}
</script>
